import {StockQuantPackage} from "../sdk";

export class IStockQuantPackage extends StockQuantPackage {
    public static readonly FIELDS: Array<string> = [
        "id",
        "name",
        "quant_ids",
        "location_id",
        "epc_code"
    ];

    public static readonly FILTER_INCLUDE:any = [
        {
            "relation": "quants",
            "scope": {
                "fields": ["id", "name", "location_id", "lot_id", "product_id", "product_uom_id", "quantity"],
                "include": [
                    {
                        "relation": "location",
                        "scope": {"fields": ["id", "name"]}
                    },
                    {
                        "relation": "lot",
                        "scope": {"fields": ["id", "name"]}
                    },
                    {
                        "relation": "product",
                        "scope": {"fields": ["id", "name"]}
                    },
                    {
                        "relation": "productUom",
                        "scope": {"fields": ["id", "name"]}
                    }
                ]
            }
        },
        {
            "relation": "location",
            "scope": {"fields": ["id", "name"]}
        },
    ]

    constructor(json: StockQuantPackage) {
        super(json);
    }
}


// WEBPACK FOOTER //
// ./src/models/iStockQuantPackage.ts